import { createSelector } from '@reduxjs/toolkit';

import { Region } from '@paragon/contract-library';

import { RootState } from '../store';
import { loggedInUser } from './users';

const getRegions = (state: RootState) => state.sealsAndSignatures.regions;
const getSelectedRegion = (state: RootState) => state.sealsAndSignatures.selectedRegion;

export const sealRegionsForLoggedInUser = createSelector(loggedInUser, getRegions, (user, regions) => {
  const sealedRegions: Region[] = [];
  const unsealedRegions: Region[] = [];
  regions.forEach((region) => {
    const sealRegion = user!.seals.find((seal) => seal.region === region.name);
    if (sealRegion === undefined) unsealedRegions.push(region);
    else sealedRegions.push(region);
  });
  return {
    sealedRegions,
    unsealedRegions,
  };
});

export const sealForSelectedRegionForLoggedInUser = createSelector(
  loggedInUser,
  getSelectedRegion,
  (user, selectedRegion) => user!.seals.find((seal) => seal.region === selectedRegion!.name),
);
